import { render, staticRenderFns } from "./QRReader.vue?vue&type=template&id=04a4ff98&scoped=true&"
import script from "./QRReader.vue?vue&type=script&lang=js&"
export * from "./QRReader.vue?vue&type=script&lang=js&"
import style0 from "./QRReader.vue?vue&type=style&index=0&id=04a4ff98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a4ff98",
  null
  
)

export default component.exports